var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavComponent'),_c('b-container',[_c('b-row',[_c('b-col',[_c('h5',[_vm._v("Current Calling Users")])])],1),_c('b-row',[_c('b-col',[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.items}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }